module.exports = __webpack_public_path__ + "static/media/loginvdo.5c458670.mp4";